import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import Particle from "./Particle"; 

function Certification() {
  const certifications = [
    {
      title: "Free Lancing by Digital Skills",
      issuer: "Virtual University of Pakistan (VU) and Ignite – National Technology Fund.",
      date: "August 2025",
      image: "https://empmonitor.com/blog/wp-content/uploads/2025/12/Want-To-Know-The-24-Freelancing-Tips-That-Can-Skyrocket-Your-Caree.webp",
      link: "/digiskills-certificates/FREELANCING.pdf" 
    },
    {
      title: "SEO by Digital Skills",
      issuer: "Virtual University of Pakistan (VU) and Ignite – National Technology Fund.",
      date: "August 2025",
      image: "https://universidadeuropea.com/resources/media/images/shutterstock_178962923_1_1.width-1200.format-webp.webp",
      link: "/digiskills-certificates/SEO.pdf"
    }
  ];

  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My <strong className="purple">Certifications </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few professional certifications I've earned along the way.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          {certifications.map((cert, index) => (
            <Col md={4} className="project-card" key={index}>
              <Card className="project-card-view">
                <Card.Img variant="top" src={cert.image} alt="card-img" />
                <Card.Body>
                  <Card.Title>{cert.title}</Card.Title>
                  <Card.Text style={{ textAlign: "justify" }}>
                    <strong>Issuer:</strong> {cert.issuer} <br />
                    <strong>Date:</strong> {cert.date}
                  </Card.Text>
                  
                  <Button 
                    variant="primary" 
                    href={cert.link} 
                    target="_blank" 
                    rel="noopener noreferrer"
                  >
                    View Certificate
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </Container>
  );
}

export default Certification;